import { useEffect, useState } from "react";
import { Eye, FileText } from "lucide-react";
import axios from "axios";

export default function Tender() {
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch tenders data from the backend API
  useEffect(() => {
    const fetchTenders = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/tenders`);
        setTenders(response.data);
      } catch (err) {
        console.error(err); // Log detailed error for debugging
        setError(
          err.response?.data?.message || "Failed to fetch tenders. Please try again later."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTenders();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <span className="text-xl text-gray-700">Loading...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <span className="text-xl text-red-600">{error}</span>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      {/* Main Content */}
      <main className="container mx-auto px-4 md:px-6 lg:px-8 py-6">
        {/* Action Button */}
        <a
          href="https://mptenders.gov.in/nicgep/app"
          target="_blank"
          rel="noopener noreferrer"
          className="block bg-gradient-to-r from-teal-500 to-cyan-600 text-white font-semibold text-lg py-3 rounded-md text-center shadow-md hover:shadow-lg transition-transform transform hover:scale-105 mb-6"
        >
          Click Here To View All TENDERS MADHYA PRADESH &gt;
        </a>

        {/* Responsive Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-teal-100">
              <tr>
                <th className="text-left py-3 px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">
                  S No.
                </th>
                <th className="text-left py-3 px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">
                  Description
                </th>
                <th className="text-left py-3 px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">
                  Publication Date
                </th>
                <th className="text-left py-3 px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">
                  Last Submission Date
                </th>
                <th className="text-left py-3 px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">
                  Opening Date
                </th>
                <th className="text-center py-3 px-4 font-bold text-gray-700 text-xs sm:text-sm uppercase tracking-wide">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {tenders.map((tender, index) => (
                <tr key={tender._id} className="hover:bg-teal-50 transition-colors">
                  <td className="py-3 px-4 text-gray-700 text-xs sm:text-sm">{index + 1}</td>
                  <td className="py-3 px-4 text-gray-700 text-xs sm:text-sm">
                    {tender.description}
                  </td>
                  <td className="py-3 px-4 text-gray-500 text-xs sm:text-sm">
                    {tender.publicationDate || "-"}
                  </td>
                  <td className="py-3 px-4 text-gray-500 text-xs sm:text-sm">
                    {tender.lastSubmissionDate || "-"}
                  </td>
                  <td className="py-3 px-4 text-gray-500 text-xs sm:text-sm">
                    {tender.openingDate || "-"}
                  </td>
                  <td className="py-3 px-4">
                    <div className="flex justify-center gap-2">
                      {/* Download PDF Button */}
                      <a
                        href={tender.pdfUrl}
                        download
                        className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 text-teal-600 transition-colors shadow-sm"
                        aria-label="Download PDF"
                      >
                        <FileText className="w-5 h-5" />
                      </a>
                      {/* View PDF Button */}
                      <a
                        href={tender.pdfUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-teal-500 hover:bg-teal-600 text-white transition-colors shadow-sm"
                        aria-label="View tender"
                      >
                        <Eye className="w-5 h-5" />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}
